export const API_PROJECT_PARTNERS_FIELDS = ['partners.id', 'partners.partner_id'];
